/** Kannada: terms other than price, the worker's own preferences, and the scope chips. */
export const terms = {
    "terms.title": "ಬೆಲೆಯ ಜೊತೆಗೆ ಒಪ್ಪಿದ್ದು",
    "terms.proposed": "ಷರತ್ತುಗಳು: {terms}",
    "terms.when": "{day}, {window}",
    "terms.window.morning": "ಬೆಳಿಗ್ಗೆ",
    "terms.window.afternoon": "ಮಧ್ಯಾಹ್ನ",
    "terms.window.evening": "ಸಂಜೆ",
    "terms.materials.worker": "ಸಾಮಗ್ರಿ ಕೆಲಸಗಾರರು ತರುತ್ತಾರೆ",
    "terms.materials.household": "ಸಾಮಗ್ರಿ ಮನೆಯವರು ಕೊಳ್ಳುತ್ತಾರೆ",
    "terms.coats.one": "ಪೇಂಟ್ {count} ಕೋಟ್",
    "terms.coats.other": "ಪೇಂಟ್ {count} ಕೋಟ್",
    "terms.hours.one": "ದಿನಕ್ಕೆ {count} ಗಂಟೆ",
    "terms.hours.other": "ದಿನಕ್ಕೆ {count} ಗಂಟೆ",
    "terms.you_asked": "(ನೀವು ಕೇಳಿದ್ದು: {value})",
    "terms.check": "ನೀವು ಕೇಳದ ಷರತ್ತುಗಳನ್ನು ನಿಮ್ಮ ಏಜೆಂಟ್ ಒಪ್ಪಿದೆ. ಸಹಿ ಮಾಡುವ ಮೊದಲು ನೋಡಿ.",
    "terms.card": "ನೀವು ಯಾವಾಗ ಕೆಲಸ ಮಾಡುತ್ತೀರಿ, ಏನು ತರುತ್ತೀರಿ",
    "terms.card_windows": "ದಿನದ ಯಾವ ಹೊತ್ತಿನಲ್ಲಿ ಕೆಲಸ ತೆಗೆದುಕೊಳ್ಳುತ್ತೀರಿ",
    "terms.card_days": "ನೀವು ಕೆಲಸ ಮಾಡುವ ದಿನಗಳು",
    "day.1": "ಸೋಮ",
    "day.2": "ಮಂಗಳ",
    "day.3": "ಬುಧ",
    "day.4": "ಗುರು",
    "day.5": "ಶುಕ್ರ",
    "day.6": "ಶನಿ",
    "day.7": "ಭಾನು",
    "terms.card_public": "ಮನೆಯವರು ನಿಮ್ಮ ಕಾರ್ಡ್‌ನಲ್ಲಿ ನಿಮ್ಮ ದಿನಗಳು ಮತ್ತು ಸಮಯ ನೋಡುತ್ತಾರೆ, ಹಾಗಾಗಿ ನೀವು ಕೆಲಸ ಮಾಡುವಾಗ ಮಾತ್ರ ಕೇಳುತ್ತಾರೆ. ನಿಮ್ಮ ಬುಕಿಂಗ್‌ಗಳು ಈ ಫೋನ್‌ನಲ್ಲೇ ಇರುತ್ತವೆ.",
    "terms.card_materials": "ಸಾಮಗ್ರಿ ಯಾರು ಕೊಳ್ಳುತ್ತಾರೆ",
    "terms.card_either": "ಯಾರಾದರೂ",
    "terms.card_mine": "ನಾನೇ ತರುತ್ತೇನೆ",
    "terms.card_theirs": "ಮನೆಯವರು ಕೊಳ್ಳಲಿ",
    "terms.card_hours": "ದಿನಕ್ಕೆ ಹೆಚ್ಚೆಂದರೆ ಗಂಟೆಗಳು",
    "terms.card_any": "ಯಾವುದಾದರೂ",
    "terms.scope_read": "ನೀವು ಬರೆದದ್ದರಲ್ಲಿ ನನಗೆ ಇದು ಸಿಕ್ಕಿತು. ತಪ್ಪಾದುದನ್ನು ಒತ್ತಿ ತೆಗೆದುಹಾಕಿ.",
    "terms.scope_ok": "ಹೌದು, ಸರಿ",
    "terms.scope_none": "ಇವುಗಳಲ್ಲಿ ಯಾವುದೂ ಅಲ್ಲ",
    "terms.chip.rooms.one": "{count} ಕೋಣೆ",
    "terms.chip.rooms.other": "{count} ಕೋಣೆಗಳು",
    "terms.chip.area_sqft": "{count} ಚದರ ಅಡಿ",
    "terms.chip.people.one": "{count} ವ್ಯಕ್ತಿ",
    "terms.chip.people.other": "{count} ಜನ",
    "terms.chip.meals.one": "ದಿನಕ್ಕೆ {count} ಊಟ",
    "terms.chip.meals.other": "ದಿನಕ್ಕೆ {count} ಊಟ",
    "terms.chip.labour_yes": "ಪೇಂಟ್ ನೀವು ಕೊಳ್ಳುತ್ತೀರಿ",
    "terms.chip.labour_no": "ಪೇಂಟ್ ಪೇಂಟರ್ ತರುತ್ತಾರೆ",
    "terms.chip.flexible": "ಆ ದಿನ ಯಾವಾಗ ಬೇಕಾದರೂ ಸರಿ",
    "terms.reading": "ನೀವು ಬರೆದದ್ದನ್ನು ಓದುತ್ತಿದ್ದೇನೆ…",
};
//# sourceMappingURL=terms.js.map